import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { extractError } from "@/lib/api";

export default function Login() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    if (user) return <Navigate to="/" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email, password);
            nav("/");
        } catch (e) {
            setErr(extractError(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4" data-testid="login-page">
            <div className="w-full max-w-sm">
                <h1 className="font-display text-3xl font-semibold tracking-tight text-neutral-900 text-center mb-6 lowercase" data-testid="login-welcome">
                    welcome to jester
                </h1>
                <form onSubmit={submit} className="p-6" data-testid="login-form">
                <label className="block">
                    <span className="text-xs font-medium text-neutral-600">Email</span>
                    <input
                        data-testid="login-email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoFocus
                        className="mt-1 w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900/20 focus:border-neutral-500"
                    />
                </label>

                <label className="block mt-4">
                    <span className="text-xs font-medium text-neutral-600">Password</span>
                    <input
                        data-testid="login-password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="mt-1 w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900/20 focus:border-neutral-500"
                    />
                </label>

                {err && (
                    <div data-testid="login-error" className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                        {err}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={busy}
                    data-testid="login-submit"
                    className="mt-5 w-full py-2 rounded-md bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-800 disabled:opacity-60 transition-colors"
                >
                    {busy ? "Accesso in corso…" : "Accedi"}
                </button>
            </form>
            </div>
        </div>
    );
}
